import { translate } from '@/domains/core/localization/translate';
export const {
  bestQualityOfferTag,
  compareWith,
  currentlyViewed,
  deliveryHeader,
  freeDelivery,
  priceHeader,
  promoTag,
  ratingHeader,
  topSaleTag,
  couponTag
} = translate({
  "bestQualityOfferTag": "The ManoMano selection",
  "compareWith": "Compare with similar items",
  "currentlyViewed": "Currently viewed",
  "deliveryHeader": "Shipping",
  "freeDelivery": "Free",
  "priceHeader": "Price",
  "promoTag": "Deal",
  "ratingHeader": "Customer Rating",
  "topSaleTag": "Best sellers",
  "couponTag": "offered"
});